import { BrowserRouter as Router, useLocation } from "react-router-dom";
import ClientApp from "./ClientApp";
import AdminApp from "./AdminApp";
import { PermissionProvider } from "./components/admin/context/PermissionContext";
import AdminLayout from "./Layout/AdminLayout";
import { WalletProvider } from './components/client/context/WalletContext'

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return isAdmin ? <PermissionProvider><AdminApp /></PermissionProvider> : <WalletProvider><ClientApp /></WalletProvider>;
}

export function RenderRout() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}